export default __webpack_public_path__ + "static/media/right-arrow.d77fbcb7.svg";